import { useState } from 'react'

const useForm = (initialValues, submitCallback, keyDownCallback) => {
  const [inputs, setInputs] = useState(initialValues)

  const handleSubmit = (event) => {
    if (event) {
      event.preventDefault()
    }
    submitCallback()
  }

  const handleInputChange = (event) => {
    console.log(event)
    if (event.target.type === 'checkbox') {
      inputs[event.target.name] = inputs[event.target.name] ? null : event.target.value
    } else if (event.target.type === 'select-multiple') {
      inputs[event.target.name] = Array.from(event.target.selectedOptions, option => option.value)
    } else {
      inputs[event.target.name] = event.target.value
    }
    setInputs(inputs)
  }

  const handleKeyDown = (event) => {
    keyDownCallback(event)
  }

  function resetInputs(newInputs) {
    setInputs(newInputs)
  }

  return {
    resetInputs,
    handleSubmit,
    handleInputChange,
    handleKeyDown,
    inputs
  }
}

export default useForm